export const ID_TYPES = {
  ORDER_ID: "order_id",
  LULU_REF_ID: "lulu_ref_id"
}